module.exports = __webpack_public_path__ + "img/icon-presentation-inactive.0b064d44.png";